import { useMsal } from '@azure/msal-react';
import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router';

export function useMicrosoftLoginCustom() {
  const { instance } = useMsal();
  const [error, setError] = useState(null);
  const { setProviderName, checkSession } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async () => {
    setError(null);
    try {
      const response = await instance.loginPopup({ prompt: 'select_account' });

      const apiResponse = await fetch(window.API_URL + '/extranet/connexion/microsoft', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          utilisateur: {
            email: response.account.username,
            microsoft_access_token: response.accessToken,
          },
        }),
      });

      if (!apiResponse.ok) {
        throw new Error(`Erreur API : ${apiResponse.status}`);
      }

      const apiData = await apiResponse.json();

      localStorage.setItem('client_id', apiData.client_id);
      localStorage.setItem('userName', response.account.name);

      setProviderName('Microsoft');
      await checkSession();
      navigate('/tickets');
    } catch (e) {
      console.error('Erreur connexion Microsoft :', e);
      setError('Erreur lors de la connexion avec Microsoft');
    }
  };

  return { handleLogin, error };
}
